import { render, staticRenderFns } from "./DateObject.vue?vue&type=template&id=1b589ad2&scoped=true&"
import script from "./DateObject.vue?vue&type=script&lang=ts&"
export * from "./DateObject.vue?vue&type=script&lang=ts&"
import style0 from "./DateObject.vue?vue&type=style&index=0&id=1b589ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b589ad2",
  null
  
)

export default component.exports